import { FieldType } from 'constants/formGenerator';

import { MAX_LENGTH_REASON_NOTE } from '../../CicFeeReasonEditItem/CicFeeReasonEditItem.constants';

export const LOAN_CIC_REASONS_MODAL_HEADER = 'Loan-Level CIC Reasons';

export const LOAN_CIC_REASONS_EMPTY_MESSAGE = 'No loan-level CIC reasons found';

export const getLoanCicReasonFormConfig = loanCicReasons => ({
  groups: loanCicReasons.map(({ loanCicReasonId }) => ({
    type: FieldType.GROUP,
    key: `loan-cic-reason-${loanCicReasonId}`,
    fields: [
      {
        type: FieldType.INPUT,
        nameInModel: `${loanCicReasonId}.textNote`,
        inputProps: { maxLength: MAX_LENGTH_REASON_NOTE, label: 'Note' },
      },
      {
        type: FieldType.INPUT,
        nameInModel: `${loanCicReasonId}.reasonStatus`,
        inputProps: { label: 'Status' },
      },
      {
        type: FieldType.INPUT,
        nameInModel: `${loanCicReasonId}.modifiedDate`,
        inputProps: { label: 'Modified Date' },
      },
      {
        type: FieldType.INPUT,
        nameInModel: `${loanCicReasonId}.modifiedBy`,
        inputProps: { label: 'Modified By' },
      },
    ],
  })),
});
